import { render, staticRenderFns } from "./newDigitalForms.vue?vue&type=template&id=1bde5448"
import script from "./newDigitalForms.vue?vue&type=script&lang=js"
export * from "./newDigitalForms.vue?vue&type=script&lang=js"
import style0 from "./newDigitalForms.vue?vue&type=style&index=0&id=1bde5448&prod&lang=css"
import style1 from "./newDigitalForms.vue?vue&type=style&index=1&id=1bde5448&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports